export const dashboardIcon = (color?: string) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33333 10V11.3333M8 7.33333V11.3333M10.6667 4.66667V11.3333M5.2 14H10.8C11.9201 14 12.4802 14 12.908 13.782C13.2843 13.5903 13.5903 13.2843 13.782 12.908C14 12.4802 14 11.9201 14 10.8V5.2C14 4.0799 14 3.51984 13.782 3.09202C13.5903 2.71569 13.2843 2.40973 12.908 2.21799C12.4802 2 11.9201 2 10.8 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.71569 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.0799 2 5.2V10.8C2 11.9201 2 12.4802 2.21799 12.908C2.40973 13.2843 2.71569 13.5903 3.09202 13.782C3.51984 14 4.0799 14 5.2 14Z"
        stroke={color ?? "#717680"}
        strokeWidth="1.336"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const locationIcon = (color?: string) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99996 8.66671C9.10453 8.66671 9.99996 7.77128 9.99996 6.66671C9.99996 5.56214 9.10453 4.66671 7.99996 4.66671C6.89539 4.66671 5.99996 5.56214 5.99996 6.66671C5.99996 7.77128 6.89539 8.66671 7.99996 8.66671Z"
        stroke={color ?? "#717680"}
        strokeWidth="1.34"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99996 14.6667C10.6666 12 13.3333 9.61223 13.3333 6.66671C13.3333 3.72119 10.9455 1.33337 7.99996 1.33337C5.05444 1.33337 2.66663 3.72119 2.66663 6.66671C2.66663 9.61223 5.33329 12 7.99996 14.6667Z"
        stroke={color ?? "#717680"}
        strokeWidth="1.34"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const editLocationIcon = (color?: string) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.9623 2.00048C10.5132 1.99657 10.7828 2.01611 11.15 2.07862C11.4157 2.12159 11.8064 2.20364 12.0212 2.25443C12.2361 2.30912 12.5799 2.41852 12.7831 2.49275C12.9863 2.57089 13.3574 2.73107 13.6036 2.85609C13.8497 2.98111 14.213 3.18818 14.4045 3.3132C14.5959 3.44213 14.8889 3.6531 15.0491 3.78203C15.2093 3.91096 15.5453 4.22742 15.7914 4.48528C16.0376 4.73923 16.3579 5.1182 16.5025 5.32136C16.647 5.52452 16.8697 5.87224 16.9987 6.09884C17.1237 6.32544 17.2995 6.67706 17.3854 6.88022C17.4753 7.08338 17.6081 7.46235 17.6863 7.72021C17.7644 7.97807 17.8621 8.3922 17.9051 8.63833C17.948 8.88447 17.9949 9.33377 18.0301 10.1816L17.0846 11.1388C16.4556 11.7717 16.147 12.0647 16.1626 11.9983C16.1743 11.9436 16.229 11.7404 16.2798 11.549C16.3306 11.3576 16.3892 11.0606 16.4126 10.8965C16.4361 10.7285 16.4556 10.3496 16.4556 10.0565C16.4556 9.75962 16.4283 9.33377 16.3931 9.10716C16.3618 8.88056 16.2915 8.52894 16.2368 8.32578C16.1782 8.12262 16.0766 7.80616 16.0024 7.62254C15.9282 7.43891 15.7836 7.13808 15.682 6.94664C15.5805 6.75911 15.3851 6.44265 15.2445 6.2473C15.1038 6.04805 14.8147 5.70814 14.5998 5.49326C14.3849 5.27448 14.0489 4.98146 13.8575 4.8369C13.6661 4.69235 13.3457 4.48919 13.1543 4.37979C12.9628 4.2743 12.6542 4.12584 12.4705 4.05161C12.2869 3.97738 11.9783 3.86799 11.7868 3.81329C11.5954 3.75859 11.275 3.68436 11.0836 3.6492C10.8375 3.60231 10.5171 3.58278 10.0092 3.58278C9.50519 3.58278 9.18092 3.60231 8.93478 3.6492C8.74334 3.68436 8.42298 3.75859 8.23154 3.81329C8.0401 3.87189 7.69629 3.99301 7.46969 4.09068C7.24309 4.18835 6.92663 4.34854 6.76644 4.4423C6.60626 4.53998 6.33668 4.71969 6.16478 4.84081C5.99678 4.96192 5.68032 5.23931 5.46153 5.4581C5.24665 5.67689 4.96535 5.99335 4.84424 6.16135C4.72312 6.32934 4.53559 6.61846 4.4262 6.80208C4.3168 6.98571 4.16053 7.30217 4.07457 7.50533C3.98862 7.70849 3.87532 8.03667 3.81672 8.22811C3.76202 8.41955 3.68779 8.73991 3.65263 8.93135C3.60574 9.1814 3.58621 9.50958 3.58621 10.0644C3.5823 10.6856 3.59793 10.9122 3.65653 11.1778C3.6956 11.3615 3.76983 11.6428 3.81672 11.8029C3.8636 11.9631 3.96518 12.2561 4.03941 12.4476C4.11364 12.639 4.29336 13.0297 4.43401 13.3071C4.57466 13.5845 4.83252 14.0455 5.00833 14.3229C5.18414 14.6003 5.46153 15.0144 5.62562 15.241C5.78971 15.4676 6.09836 15.8661 6.30543 16.1318C6.5164 16.3936 6.90318 16.8507 7.16495 17.1476C7.4228 17.4406 8.02838 18.0696 8.50502 18.5424C8.98167 19.0151 9.51301 19.523 10.0053 19.9489L10.0092 22L9.52863 21.6054C9.26687 21.3905 8.82539 21.0037 8.54409 20.7498C8.26279 20.4997 7.71192 19.9684 7.31341 19.5699C6.91491 19.1753 6.34449 18.5736 6.04366 18.2337C5.74283 17.8938 5.29744 17.3664 5.05521 17.0656C4.81298 16.7608 4.44182 16.2646 4.23085 15.9638C4.01988 15.663 3.71123 15.1863 3.54323 14.9089C3.37524 14.6315 3.10175 14.1197 2.93375 13.7759C2.76576 13.4321 2.5665 12.975 2.48836 12.7601C2.41023 12.5453 2.29302 12.1663 2.23051 11.9201C2.168 11.674 2.08986 11.2716 2.0586 11.0294C2.02735 10.791 2 10.373 2 10.1034C2 9.83385 2.01953 9.44316 2.03907 9.23219C2.06251 9.02512 2.10939 8.71257 2.14065 8.54066C2.1719 8.36876 2.24223 8.06011 2.29693 7.85695C2.35162 7.65379 2.46102 7.32561 2.53525 7.13417C2.61339 6.93882 2.75404 6.62627 2.85171 6.43092C2.94938 6.23558 3.09784 5.966 3.1838 5.82535C3.27366 5.6847 3.4651 5.4034 3.61746 5.20024C3.76593 4.99709 4.10192 4.61811 4.35978 4.35635C4.62154 4.09849 5.00051 3.7625 5.20367 3.61404C5.40683 3.46167 5.68813 3.27023 5.82878 3.18037C5.96943 3.09442 6.22729 2.94986 6.40701 2.86C6.58282 2.77405 6.90318 2.62949 7.11806 2.54354C7.33295 2.45759 7.70801 2.33647 7.95024 2.27396C8.18856 2.20754 8.52846 2.13722 8.70037 2.10987C8.87227 2.08643 9.06371 2.05127 9.13013 2.03564C9.19655 2.01611 9.5677 2.00048 9.9623 2.00048ZM18.6435 11.7678C18.6552 11.7639 19.4092 12.5101 21.9839 15.0848L21.3549 15.7177C21.0111 16.0693 19.8038 17.3039 18.6786 18.4603C17.5534 19.6207 16.5455 20.6365 16.4361 20.7224C16.3306 20.8045 16.1196 20.9334 15.9672 21.0037C15.7524 21.1092 15.3265 21.2186 13.9356 21.5273C12.9706 21.7421 12.1189 21.9375 12.0525 21.9609C11.9822 21.9805 11.9158 21.9961 11.904 21.9922C11.8923 21.9844 12.0759 21.117 12.3143 20.0661C12.6229 18.7104 12.7792 18.0853 12.8612 17.9173C12.9198 17.7883 13.041 17.593 13.123 17.4836C13.205 17.3703 14.4748 16.0419 15.9477 14.5261C17.4206 13.0102 18.6318 11.7678 18.6435 11.7678ZM16.7799 15.9169C15.7524 16.9757 14.803 17.9524 14.6701 18.0931L14.4279 18.347L15.5375 19.4566C18.8076 16.0927 19.7609 15.1043 19.7687 15.0887C19.7726 15.0769 19.5225 14.823 19.2139 14.53L18.6513 13.9947L16.7799 15.9169ZM10.1225 6.30981C10.4116 6.31762 10.6929 6.35669 10.9039 6.41139C11.0875 6.45827 11.3766 6.55985 11.5485 6.6419C11.7204 6.72004 11.9666 6.85678 12.0955 6.94664C12.2244 7.03259 12.4198 7.18105 12.5252 7.27873C12.6346 7.3764 12.8222 7.58347 12.9433 7.74365C13.0644 7.89993 13.2363 8.17341 13.3223 8.34532C13.4082 8.51722 13.5254 8.81415 13.5801 9.00949C13.6543 9.25953 13.6895 9.49004 13.7051 9.81041C13.7208 10.0722 13.709 10.3808 13.6817 10.5527C13.6582 10.7129 13.5762 11.0216 13.502 11.2364C13.4277 11.4513 13.2832 11.7639 13.1816 11.9358C13.0761 12.1116 12.8495 12.3929 12.662 12.5843C12.4823 12.7719 12.1892 13.018 12.0173 13.1274C11.8454 13.2407 11.5759 13.3813 11.4118 13.4399C11.2516 13.5024 11.0055 13.5845 10.8648 13.6236C10.6695 13.6783 10.4741 13.6939 9.98574 13.6939C9.41924 13.69 9.32938 13.6822 9.00901 13.5845C8.81757 13.5259 8.51674 13.4048 8.34484 13.3227C8.17293 13.2368 7.90336 13.0649 7.74317 12.9438C7.5869 12.8187 7.37592 12.6312 7.27825 12.5257C7.18448 12.4163 7.03211 12.2249 6.94616 12.096C6.86021 11.967 6.72347 11.7209 6.64142 11.549C6.56328 11.3771 6.4578 11.088 6.40701 10.9043C6.33668 10.6348 6.32105 10.4668 6.31715 10.0253C6.31715 9.58381 6.33277 9.408 6.4031 9.1267C6.45389 8.93135 6.57891 8.59927 6.6844 8.38438C6.78988 8.1695 6.98523 7.85304 7.12197 7.68505C7.25871 7.51705 7.50876 7.2631 7.68066 7.12636C7.85257 6.98961 8.12605 6.8099 8.28623 6.72394C8.45032 6.6419 8.68865 6.53641 8.82539 6.49344C8.95822 6.44655 9.20436 6.38404 9.37236 6.35279C9.57161 6.31372 9.82947 6.302 10.1225 6.30981ZM9.04808 8.09527C8.86055 8.18513 8.69255 8.31015 8.50111 8.50159C8.3253 8.6774 8.18465 8.86494 8.10261 9.02903C8.03228 9.16968 7.95024 9.40409 7.91898 9.55646C7.88382 9.70492 7.86038 9.9159 7.85647 10.0253C7.85647 10.1308 7.89163 10.3613 7.93852 10.5332C7.98149 10.7051 8.06354 10.9317 8.12214 11.0411C8.18075 11.1466 8.35265 11.3615 8.50111 11.5138C8.70427 11.717 8.85274 11.8264 9.06762 11.928C9.23171 12.0061 9.4544 12.0881 9.5677 12.1116C9.681 12.135 9.88026 12.1546 10.017 12.1546C10.1498 12.1546 10.3686 12.1272 10.5054 12.096C10.6382 12.0608 10.857 11.9827 10.9937 11.9123C11.1461 11.8381 11.3414 11.6857 11.5133 11.5138C11.6892 11.3419 11.8376 11.1427 11.9158 10.9903C11.9822 10.8575 12.0642 10.6387 12.0955 10.5019C12.1267 10.3691 12.1541 10.1503 12.1541 10.0136C12.1541 9.88073 12.1345 9.67758 12.1111 9.56427C12.0877 9.45097 12.0056 9.22828 11.9314 9.0681C11.8298 8.84931 11.7204 8.70475 11.5133 8.50159C11.361 8.34922 11.15 8.17732 11.0406 8.12262C10.9351 8.06402 10.7046 7.97807 10.5327 7.93509C10.3608 7.89211 10.1264 7.85695 10.0053 7.85695C9.88807 7.86086 9.68491 7.8843 9.55598 7.91165C9.42705 7.939 9.20045 8.02104 9.04808 8.09527Z"
        fill={color ?? "#717680"}
      />
    </svg>
  );
};

export const rewardIcon = (color?: string) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.31116 9.81466L4.66671 14.6667L7.72564 12.8314C7.82541 12.7715 7.87529 12.7416 7.92854 12.7299C7.97565 12.7195 8.02443 12.7195 8.07154 12.7299C8.12479 12.7416 8.17467 12.7715 8.27444 12.8314L11.3334 14.6667L10.6896 9.8142M12.6667 6.00004C12.6667 8.57737 10.5774 10.6667 8.00004 10.6667C5.42271 10.6667 3.33337 8.57737 3.33337 6.00004C3.33337 3.42271 5.42271 1.33337 8.00004 1.33337C10.5774 1.33337 12.6667 3.42271 12.6667 6.00004Z"
        stroke={color ?? "#717680"}
        strokeWidth="1.34"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const giftIcon = (color?: string) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_703_5169)">
        <path
          d="M8.00004 4.00004V14.6667M8.00004 4.00004H5.6429C5.29559 4.00004 4.96251 3.85957 4.71692 3.60952C4.47134 3.35947 4.33337 3.02033 4.33337 2.66671C4.33337 2.31309 4.47134 1.97395 4.71692 1.7239C4.96251 1.47385 5.29559 1.33337 5.6429 1.33337C7.47623 1.33337 8.00004 4.00004 8.00004 4.00004ZM8.00004 4.00004H10.3572C10.7045 4.00004 11.0376 3.85957 11.2832 3.60952C11.5287 3.35947 11.6667 3.02033 11.6667 2.66671C11.6667 2.31309 11.5287 1.97395 11.2832 1.7239C11.0376 1.47385 10.7045 1.33337 10.3572 1.33337C8.52385 1.33337 8.00004 4.00004 8.00004 4.00004ZM13.3334 7.33337V12.5334C13.3334 13.2801 13.3334 13.6535 13.188 13.9387C13.0602 14.1896 12.8562 14.3936 12.6054 14.5214C12.3201 14.6667 11.9468 14.6667 11.2 14.6667L4.80004 14.6667C4.0533 14.6667 3.67994 14.6667 3.39472 14.5214C3.14384 14.3936 2.93986 14.1896 2.81203 13.9387C2.66671 13.6535 2.66671 13.2801 2.66671 12.5334V7.33337M1.33337 5.06671L1.33337 6.26671C1.33337 6.64008 1.33337 6.82676 1.40604 6.96937C1.46995 7.09481 1.57194 7.1968 1.69738 7.26071C1.83999 7.33337 2.02667 7.33337 2.40004 7.33337L13.6 7.33337C13.9734 7.33337 14.1601 7.33337 14.3027 7.26071C14.4281 7.1968 14.5301 7.09481 14.594 6.96937C14.6667 6.82676 14.6667 6.64008 14.6667 6.26671V5.06671C14.6667 4.69334 14.6667 4.50666 14.594 4.36405C14.5301 4.23861 14.4281 4.13662 14.3027 4.0727C14.1601 4.00004 13.9734 4.00004 13.6 4.00004L2.40004 4.00004C2.02667 4.00004 1.83999 4.00004 1.69738 4.0727C1.57194 4.13662 1.46995 4.23861 1.40604 4.36405C1.33337 4.50665 1.33337 4.69334 1.33337 5.06671Z"
          stroke={color ?? "#717680"}
          strokeWidth="1.34"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_703_5169">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const usersIcon = (color?: string) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6667 14V12.6667C14.6667 11.4241 13.8169 10.38 12.6667 10.084M10.3334 2.19384C11.3107 2.58943 12 3.54754 12 4.66667C12 5.78579 11.3107 6.7439 10.3334 7.13949M11.3334 14C11.3334 12.7575 11.3334 12.1362 11.1304 11.6462C10.8597 10.9928 10.3406 10.4736 9.6872 10.203C9.19714 10 8.57589 10 7.33337 10H5.33337C4.09086 10 3.46961 10 2.97955 10.203C2.32614 10.4736 1.80701 10.9928 1.53636 11.6462C1.33337 12.1362 1.33337 12.7575 1.33337 14M9.00004 4.66667C9.00004 6.13943 7.80613 7.33333 6.33337 7.33333C4.86061 7.33333 3.66671 6.13943 3.66671 4.66667C3.66671 3.19391 4.86061 2 6.33337 2C7.80613 2 9.00004 3.19391 9.00004 4.66667Z"
        stroke={color ?? "#717680"}
        strokeWidth="1.34"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const userIcon = (color?: string) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_703_5202)">
        <path
          d="M3.54424 12.959C3.94979 12.0035 4.89666 11.3334 6.00004 11.3334H10C11.1034 11.3334 12.0503 12.0035 12.4558 12.959M10.6667 6.33337C10.6667 7.80613 9.4728 9.00004 8.00004 9.00004C6.52728 9.00004 5.33337 7.80613 5.33337 6.33337C5.33337 4.86061 6.52728 3.66671 8.00004 3.66671C9.4728 3.66671 10.6667 4.86061 10.6667 6.33337ZM14.6667 8.00004C14.6667 11.6819 11.6819 14.6667 8.00004 14.6667C4.31814 14.6667 1.33337 11.6819 1.33337 8.00004C1.33337 4.31814 4.31814 1.33337 8.00004 1.33337C11.6819 1.33337 14.6667 4.31814 14.6667 8.00004Z"
          stroke={color ?? "#717680"}
          strokeWidth="1.34"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_703_5202">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const campaignIcon = (color?: string) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33333 2.00004H5.2C4.0799 2.00004 3.51984 2.00004 3.09202 2.21803C2.71569 2.40977 2.40973 2.71574 2.21799 3.09206C2 3.51988 2 4.07994 2 5.20004V10.8C2 11.9201 2 12.4802 2.21799 12.908C2.40973 13.2843 2.71569 13.5903 3.09202 13.7821C3.51984 14 4.07989 14 5.2 14H10.8C11.9201 14 12.4802 14 12.908 13.7821C13.2843 13.5903 13.5903 13.2843 13.782 12.908C14 12.4802 14 11.9201 14 10.8V8.66671M8 5.33337H10.6667V8.00004M10.3333 2.33337V1.33337M12.9596 3.04048L13.6667 2.33337M13.6735 5.66671H14.6735M2 8.89811C2.43463 8.96522 2.87991 9.00004 3.33333 9.00004C6.25757 9.00004 8.84355 7.55177 10.4131 5.33337"
        stroke={color ?? "#717680"}
        strokeWidth="1.34"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const clientsIcon = (color?: string) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_703_5222)">
        <path
          d="M2.66672 14.545C3.06844 14.6667 3.61103 14.6667 4.53337 14.6667H11.4667C12.389 14.6667 12.9316 14.6667 13.3334 14.545M2.66672 14.545C2.58059 14.5189 2.50093 14.4872 2.42539 14.4487C2.04907 14.257 1.74311 13.951 1.55136 13.5747C1.33337 13.1469 1.33337 12.5868 1.33337 11.4667V4.53337C1.33337 3.41327 1.33337 2.85322 1.55136 2.42539C1.74311 2.04907 2.04907 1.74311 2.42539 1.55136C2.85322 1.33337 3.41327 1.33337 4.53337 1.33337H11.4667C12.5868 1.33337 13.1469 1.33337 13.5747 1.55136C13.951 1.74311 14.257 2.04907 14.4487 2.42539C14.6667 2.85322 14.6667 3.41327 14.6667 4.53337V11.4667C14.6667 12.5868 14.6667 13.1469 14.4487 13.5747C14.257 13.951 13.951 14.257 13.5747 14.4487C13.4992 14.4872 13.4195 14.5189 13.3334 14.545M2.66672 14.545C2.66694 14.0054 2.67018 13.7199 2.71795 13.4798C2.92836 12.422 3.75529 11.595 4.81313 11.3846C5.07073 11.3334 5.3805 11.3334 6.00004 11.3334H10C10.6196 11.3334 10.9294 11.3334 11.1869 11.3846C12.2448 11.595 13.0717 12.422 13.2821 13.4798C13.3299 13.7199 13.3331 14.0054 13.3334 14.545M10.6667 6.33337C10.6667 7.80613 9.4728 9.00004 8.00004 9.00004C6.52728 9.00004 5.33337 7.80613 5.33337 6.33337C5.33337 4.86061 6.52728 3.66671 8.00004 3.66671C9.4728 3.66671 10.6667 4.86061 10.6667 6.33337Z"
          stroke={color ?? "#717680"}
          strokeWidth="1.34"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_703_5222">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const surveyIcon = (color?: string) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3333 8.33325V4.53325C13.3333 3.41315 13.3333 2.85309 13.1153 2.42527C12.9236 2.04895 12.6176 1.74299 12.2413 1.55124C11.8134 1.33325 11.2534 1.33325 10.1333 1.33325H5.86663C4.74652 1.33325 4.18647 1.33325 3.75864 1.55124C3.38232 1.74299 3.07636 2.04895 2.88461 2.42527C2.66663 2.85309 2.66663 3.41315 2.66663 4.53325V11.4666C2.66663 12.5867 2.66663 13.1467 2.88461 13.5746C3.07636 13.9509 3.38232 14.2569 3.75864 14.4486C4.18647 14.6666 4.74652 14.6666 5.86663 14.6666H7.99996M9.33329 7.33325H5.33329M6.66663 9.99992H5.33329M10.6666 4.66659H5.33329M9.66663 12.6666L11 13.9999L14 10.9999"
        stroke={color ?? "#717680"}
        strokeWidth="1.34"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const profileIcon = (color?: string) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3333 14C13.3333 13.0696 13.3333 12.6044 13.2185 12.2259C12.9599 11.3736 12.293 10.7067 11.4407 10.4482C11.0622 10.3333 10.597 10.3333 9.66662 10.3333H6.3333C5.40292 10.3333 4.93773 10.3333 4.5592 10.4482C3.70693 10.7067 3.03999 11.3736 2.78145 12.2259C2.66663 12.6044 2.66663 13.0696 2.66663 14M11 5C11 6.65685 9.65681 8 7.99996 8C6.3431 8 4.99996 6.65685 4.99996 5C4.99996 3.34315 6.3431 2 7.99996 2C9.65681 2 11 3.34315 11 5Z"
        stroke={color ?? "#717680"}
        strokeWidth="1.34"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const settingsIcon = (color?: string) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.26344 12.914L6.65307 13.7903C6.7689 14.0511 6.95792 14.2728 7.19722 14.4283C7.43652 14.5839 7.71581 14.6666 8.00122 14.6666C8.28663 14.6666 8.56592 14.5839 8.80522 14.4283C9.04452 14.2728 9.23354 14.0511 9.34937 13.7903L9.739 12.914C9.8777 12.6031 10.111 12.3438 10.4057 12.1733C10.7022 12.0022 11.0452 11.9294 11.3857 11.9651L12.339 12.0666C12.6228 12.0966 12.9092 12.0436 13.1635 11.9141C13.4177 11.7846 13.629 11.5841 13.7716 11.337C13.9144 11.0899 13.9824 10.8068 13.9674 10.5218C13.9524 10.2369 13.8551 9.96245 13.6871 9.73177L13.1227 8.95622C12.9217 8.67801 12.8143 8.34313 12.816 7.99992C12.816 7.65764 12.9244 7.32415 13.1257 7.04733L13.6901 6.27177C13.858 6.04109 13.9554 5.76663 13.9704 5.4817C13.9854 5.19677 13.9173 4.91361 13.7746 4.66659C13.632 4.41941 13.4207 4.21891 13.1664 4.0894C12.9121 3.9599 12.6257 3.90694 12.342 3.93696L11.3886 4.03844C11.0482 4.07419 10.7052 4.00133 10.4086 3.83029C10.1134 3.65875 9.88001 3.39816 9.74196 3.08584L9.34937 2.20955C9.23354 1.9487 9.04452 1.72706 8.80522 1.57152C8.56592 1.41597 8.28663 1.33321 8.00122 1.33325C7.71581 1.33321 7.43652 1.41597 7.19722 1.57152C6.95792 1.72706 6.7689 1.9487 6.65307 2.20955L6.26344 3.08584C6.1254 3.39816 5.89202 3.65875 5.59678 3.83029C5.30025 4.00133 4.95722 4.07419 4.61678 4.03844L3.66048 3.93696C3.3767 3.90694 3.09031 3.9599 2.83602 4.0894C2.58174 4.21891 2.37049 4.41941 2.22789 4.66659C2.0851 4.91361 2.01708 5.19677 2.03207 5.4817C2.04705 5.76663 2.14441 6.04109 2.31233 6.27177L2.87678 7.04733C3.07807 7.32415 3.18647 7.65764 3.18641 7.99992C3.18647 8.34219 3.07807 8.67569 2.87678 8.95251L2.31233 9.72807C2.14441 9.95875 2.04705 10.2332 2.03207 10.5181C2.01708 10.8031 2.0851 11.0862 2.22789 11.3333C2.37063 11.5803 2.58191 11.7807 2.83615 11.9102C3.0904 12.0397 3.37672 12.0927 3.66048 12.0629L4.61381 11.9614C4.95426 11.9256 5.29729 11.9985 5.59381 12.1695C5.89017 12.3406 6.12462 12.6012 6.26344 12.914Z"
        stroke={color ?? "#717680"}
        strokeWidth="1.34"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00003 9.99992C9.1046 9.99992 10 9.10449 10 7.99992C10 6.89535 9.1046 5.99992 8.00003 5.99992C6.89546 5.99992 6.00003 6.89535 6.00003 7.99992C6.00003 9.10449 6.89546 9.99992 8.00003 9.99992Z"
        stroke={color ?? "#717680"}
        strokeWidth="1.34"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const reportingIcon = (color?: string) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33329 7.33337H5.33329M6.66663 10H5.33329M10.6666 4.66671H5.33329M13.3333 4.53337V11.4667C13.3333 12.5868 13.3333 13.1469 13.1153 13.5747C12.9236 13.951 12.6176 14.257 12.2413 14.4487C11.8134 14.6667 11.2534 14.6667 10.1333 14.6667H5.86663C4.74652 14.6667 4.18647 14.6667 3.75864 14.4487C3.38232 14.257 3.07636 13.951 2.88461 13.5747C2.66663 13.1469 2.66663 12.5868 2.66663 11.4667V4.53337C2.66663 3.41327 2.66663 2.85322 2.88461 2.42539C3.07636 2.04907 3.38232 1.74311 3.75864 1.55136C4.18647 1.33337 4.74652 1.33337 5.86663 1.33337H10.1333C11.2534 1.33337 11.8134 1.33337 12.2413 1.55136C12.6176 1.74311 12.9236 2.04907 13.1153 2.42539C13.3333 2.85322 13.3333 3.41327 13.3333 4.53337Z"
        stroke={color ?? "#717680"}
        strokeWidth="1.34"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const logoutIcon = (color?: string) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5.33333L14.6667 8M14.6667 8L12 10.6667M14.6667 8H6.00004M10 2.80269C9.15021 2.29218 8.16354 2 7.11115 2C3.92017 2 1.33337 4.68629 1.33337 8C1.33337 11.3137 3.92017 14 7.11115 14C8.16354 14 9.15021 13.7078 10 13.1973"
        stroke={color ?? "#717680"}
        strokeWidth="1.34"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const deleteIcon = (color?: string) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10.6667 4.00004V3.46671C10.6667 2.71997 10.6667 2.3466 10.5213 2.06139C10.3935 1.8105 10.1895 1.60653 9.93865 1.4787C9.65344 1.33337 9.28007 1.33337 8.53333 1.33337H7.46667C6.71993 1.33337 6.34656 1.33337 6.06135 1.4787C5.81046 1.60653 5.60649 1.8105 5.47866 2.06139C5.33333 2.3466 5.33333 2.71997 5.33333 3.46671V4.00004M6.66667 7.66671V11M9.33333 7.66671V11M2 4.00004H14M12.6667 4.00004V11.4667C12.6667 12.5868 12.6667 13.1469 12.4487 13.5747C12.2569 13.951 11.951 14.257 11.5746 14.4487C11.1468 14.6667 10.5868 14.6667 9.46667 14.6667H6.53333C5.41323 14.6667 4.85318 14.6667 4.42535 14.4487C4.04903 14.257 3.74307 13.951 3.55132 13.5747C3.33333 13.1469 3.33333 12.5868 3.33333 11.4667V4.00004"
        stroke={color || "#A4A7AE"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const editIcon = (color?: string) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_1048_491)">
        <path
          d="M12.0001 6.66671L9.33343 4.00004M1.66675 14.3334L3.92299 14.0827C4.19865 14.0521 4.33648 14.0367 4.46531 13.995C4.57961 13.958 4.68838 13.9058 4.78867 13.8396C4.90172 13.7651 4.99978 13.667 5.1959 13.4709L14.0001 4.66671C14.7365 3.93033 14.7365 2.73642 14.0001 2.00004C13.2637 1.26366 12.0698 1.26366 11.3334 2.00004L2.52923 10.8042C2.33311 11.0003 2.23505 11.0984 2.16051 11.2114C2.09437 11.3117 2.04209 11.4205 2.00509 11.5348C1.96339 11.6636 1.94807 11.8015 1.91744 12.0771L1.66675 14.3334Z"
          stroke={color || "#A4A7AE"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1048_491">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const adminIcon = (color?: string) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10.6667 2.31184C11.6545 2.80274 12.3334 3.82209 12.3334 5C12.3334 6.17791 11.6545 7.19726 10.6667 7.68816M12 11.1776C13.0077 11.6336 13.9151 12.3767 14.6667 13.3333M1.33337 13.3333C2.63103 11.6817 4.39283 10.6667 6.33337 10.6667C8.27392 10.6667 10.0357 11.6817 11.3334 13.3333M9.33337 5C9.33337 6.65685 7.99023 8 6.33337 8C4.67652 8 3.33337 6.65685 3.33337 5C3.33337 3.34315 4.67652 2 6.33337 2C7.99023 2 9.33337 3.34315 9.33337 5Z"
        stroke={color || "#717680"}
        strokeWidth="1.34"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const emailIcon = (color?: string) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M1.33325 4.66675L6.77653 8.47704C7.21731 8.78559 7.4377 8.93986 7.67743 8.99962C7.88918 9.0524 8.11066 9.0524 8.32241 8.99962C8.56213 8.93986 8.78252 8.78559 9.2233 8.47704L14.6666 4.66675M4.53325 13.3334H11.4666C12.5867 13.3334 13.1467 13.3334 13.5746 13.1154C13.9509 12.9237 14.2569 12.6177 14.4486 12.2414C14.6666 11.8136 14.6666 11.2535 14.6666 10.1334V5.86675C14.6666 4.74664 14.6666 4.18659 14.4486 3.75877C14.2569 3.38244 13.9509 3.07648 13.5746 2.88473C13.1467 2.66675 12.5867 2.66675 11.4666 2.66675H4.53325C3.41315 2.66675 2.85309 2.66675 2.42527 2.88473C2.04895 3.07648 1.74299 3.38244 1.55124 3.75877C1.33325 4.18659 1.33325 4.74664 1.33325 5.86675V10.1334C1.33325 11.2535 1.33325 11.8136 1.55124 12.2414C1.74299 12.6177 2.04895 12.9237 2.42527 13.1154C2.85309 13.3334 3.41315 13.3334 4.53325 13.3334Z"
        stroke={color || "black"}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const lockIcon = (color?: string) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M11.3334 6.66667V5.33333C11.3334 3.49238 9.84103 2 8.00008 2C6.15913 2 4.66675 3.49238 4.66675 5.33333V6.66667M8.00008 9.66667V11M5.86675 14H10.1334C11.2535 14 11.8136 14 12.2414 13.782C12.6177 13.5903 12.9237 13.2843 13.1154 12.908C13.3334 12.4802 13.3334 11.9201 13.3334 10.8V9.86667C13.3334 8.74656 13.3334 8.18651 13.1154 7.75869C12.9237 7.38236 12.6177 7.0764 12.2414 6.88465C11.8136 6.66667 11.2535 6.66667 10.1334 6.66667H5.86675C4.74664 6.66667 4.18659 6.66667 3.75877 6.88465C3.38244 7.0764 3.07648 7.38236 2.88473 7.75869C2.66675 8.18651 2.66675 8.74656 2.66675 9.86667V10.8C2.66675 11.9201 2.66675 12.4802 2.88473 12.908C3.07648 13.2843 3.38244 13.5903 3.75877 13.782C4.18659 14 4.74664 14 5.86675 14Z"
        stroke={color || "black"}
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const userActivateIcon = (color?: string) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="user-check-01">
        <path
          id="Icon"
          d="M7.99992 10.3333H4.99992C4.06954 10.3333 3.60435 10.3333 3.22582 10.4482C2.37356 10.7067 1.70661 11.3736 1.44808 12.2259C1.33325 12.6044 1.33325 13.0696 1.33325 14M10.6666 12L11.9999 13.3333L14.6666 10.6667M9.66659 5C9.66659 6.65685 8.32344 8 6.66659 8C5.00973 8 3.66659 6.65685 3.66659 5C3.66659 3.34315 5.00973 2 6.66659 2C8.32344 2 9.66659 3.34315 9.66659 5Z"
          stroke={color || "#A4A7AE"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const userDeactivateIcon = (color?: string) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="user-x-01">
        <path
          id="Icon"
          d="M10.9999 10.6667L14.3333 14M14.3333 10.6667L10.9999 14M7.99992 10.3333H4.99992C4.06954 10.3333 3.60435 10.3333 3.22582 10.4482C2.37356 10.7067 1.70661 11.3736 1.44808 12.2259C1.33325 12.6044 1.33325 13.0696 1.33325 14M9.66659 5C9.66659 6.65685 8.32344 8 6.66659 8C5.00973 8 3.66659 6.65685 3.66659 5C3.66659 3.34315 5.00973 2 6.66659 2C8.32344 2 9.66659 3.34315 9.66659 5Z"
          stroke={color || "#A4A7AE"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const removeIcon = (color?: string) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6667 3.99967V3.46634C10.6667 2.7196 10.6667 2.34624 10.5213 2.06102C10.3935 1.81014 10.1895 1.60616 9.93865 1.47833C9.65344 1.33301 9.28007 1.33301 8.53333 1.33301H7.46667C6.71993 1.33301 6.34656 1.33301 6.06135 1.47833C5.81046 1.60616 5.60649 1.81014 5.47866 2.06102C5.33333 2.34624 5.33333 2.7196 5.33333 3.46634V3.99967M6.66667 7.66634V10.9997M9.33333 7.66634V10.9997M2 3.99967H14M12.6667 3.99967V11.4663C12.6667 12.5864 12.6667 13.1465 12.4487 13.5743C12.2569 13.9506 11.951 14.2566 11.5746 14.4484C11.1468 14.6663 10.5868 14.6663 9.46667 14.6663H6.53333C5.41323 14.6663 4.85318 14.6663 4.42535 14.4484C4.04903 14.2566 3.74307 13.9506 3.55132 13.5743C3.33333 13.1465 3.33333 12.5864 3.33333 11.4663V3.99967"
        stroke={color || "#A4A7AE"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const clientActivateIcon = (color?: string) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
        fill="#2354D2"
      />
      <g clipPath="url(#clip0_2718_14584)">
        <path
          d="M18.6666 11.334L19.9999 12.6673L22.6666 10.0007M22.6666 16.0007V19.4673C22.6666 20.5874 22.6666 21.1475 22.4486 21.5753C22.2569 21.9516 21.9509 22.2576 21.5746 22.4493C21.1467 22.6673 20.5867 22.6673 19.4666 22.6673H12.5333C11.4131 22.6673 10.8531 22.6673 10.4253 22.4493C10.0489 22.2576 9.74299 21.9516 9.55124 21.5753C9.33325 21.1475 9.33325 20.5874 9.33325 19.4673V12.534C9.33325 11.4139 9.33325 10.8538 9.55124 10.426C9.74299 10.0497 10.0489 9.74372 10.4253 9.55197C10.8531 9.33398 11.4131 9.33398 12.5333 9.33398H15.9999M9.43026 21.2849C9.74302 20.1597 10.775 19.334 11.9998 19.334H16.6664C17.286 19.334 17.5957 19.334 17.8533 19.3852C18.9112 19.5956 19.7381 20.4226 19.9485 21.4804C19.9998 21.738 19.9998 22.0478 19.9998 22.6673M17.3333 14.334C17.3333 15.8067 16.1393 17.0007 14.6666 17.0007C13.1938 17.0007 11.9999 15.8067 11.9999 14.334C11.9999 12.8612 13.1938 11.6673 14.6666 11.6673C16.1393 11.6673 17.3333 12.8612 17.3333 14.334Z"
          stroke={color || "#FFFFFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2718_14584">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(8 8)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const clientDeactivateIcon = (color?: string) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
        fill="#2354D2"
      />
      <g clipPath="url(#clip0_2718_2701)">
        <path
          d="M18.9999 9.66732L22.3333 13.0007M22.3333 9.66732L18.9999 13.0007M22.6666 16.0007V19.4673C22.6666 20.5874 22.6666 21.1475 22.4486 21.5753C22.2569 21.9516 21.9509 22.2576 21.5746 22.4493C21.1467 22.6673 20.5867 22.6673 19.4666 22.6673H12.5333C11.4131 22.6673 10.8531 22.6673 10.4253 22.4493C10.0489 22.2576 9.74299 21.9516 9.55124 21.5753C9.33325 21.1475 9.33325 20.5874 9.33325 19.4673V12.534C9.33325 11.4139 9.33325 10.8538 9.55124 10.426C9.74299 10.0497 10.0489 9.74372 10.4253 9.55197C10.8531 9.33398 11.4131 9.33398 12.5333 9.33398H15.9999M9.43026 21.2849C9.74302 20.1597 10.775 19.334 11.9998 19.334H16.6664C17.286 19.334 17.5957 19.334 17.8533 19.3852C18.9112 19.5956 19.7381 20.4226 19.9485 21.4804C19.9998 21.738 19.9998 22.0478 19.9998 22.6673M17.3333 14.334C17.3333 15.8067 16.1393 17.0007 14.6666 17.0007C13.1938 17.0007 11.9999 15.8067 11.9999 14.334C11.9999 12.8612 13.1938 11.6673 14.6666 11.6673C16.1393 11.6673 17.3333 12.8612 17.3333 14.334Z"
          stroke={color || "#FFFFFF"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2718_2701">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(8 8)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const eyeIcon = (color?: string) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M1.61342 8.47513C1.52262 8.33137 1.47723 8.25949 1.45182 8.14862C1.43273 8.06534 1.43273 7.93401 1.45182 7.85073C1.47723 7.73986 1.52262 7.66798 1.61341 7.52422C2.36369 6.33624 4.59693 3.33301 8.00027 3.33301C11.4036 3.33301 13.6369 6.33623 14.3871 7.52422C14.4779 7.66798 14.5233 7.73986 14.5487 7.85073C14.5678 7.93401 14.5678 8.06534 14.5487 8.14862C14.5233 8.25949 14.4779 8.33137 14.3871 8.47513C13.6369 9.66311 11.4036 12.6663 8.00027 12.6663C4.59693 12.6663 2.36369 9.66311 1.61342 8.47513Z"
        stroke={color || "#A4A7AE"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00027 9.99967C9.10484 9.99967 10.0003 9.10424 10.0003 7.99967C10.0003 6.89511 9.10484 5.99967 8.00027 5.99967C6.8957 5.99967 6.00027 6.89511 6.00027 7.99967C6.00027 9.10424 6.8957 9.99967 8.00027 9.99967Z"
        stroke={color || "#A4A7AE"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const downloadIcon = (color?: string) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14 10V10.8C14 11.9201 14 12.4802 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.4802 14 11.9201 14 10.8 14H5.2C4.07989 14 3.51984 14 3.09202 13.782C2.71569 13.5903 2.40973 13.2843 2.21799 12.908C2 12.4802 2 11.9201 2 10.8V10M11.3333 6.66667L8 10M8 10L4.66667 6.66667M8 10V2"
        stroke={color || "#A4A7AE"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const markerIcon = (color?: string) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.1">
        <rect width="40" height="40" rx="20" fill={color || "#2B68E5"} />
      </g>
      <g opacity="0.2">
        <rect
          x="8"
          y="8"
          width="24"
          height="24"
          rx="12"
          fill={color || "#2B68E5"}
        />
      </g>
      <rect
        x="16"
        y="16"
        width="8"
        height="8"
        rx="4"
        fill={color || "#2B68E5"}
      />
    </svg>
  );
};

export const crossCircleIcon = (color?: string) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_3823_13217)">
        <path
          d="M10.0002 5.99967L6.00016 9.99967M6.00016 5.99967L10.0002 9.99967M14.6668 7.99967C14.6668 11.6816 11.6821 14.6663 8.00016 14.6663C4.31826 14.6663 1.3335 11.6816 1.3335 7.99967C1.3335 4.31778 4.31826 1.33301 8.00016 1.33301C11.6821 1.33301 14.6668 4.31778 14.6668 7.99967Z"
          stroke={color || "white"}
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3823_13217">
          <rect width="16" height="16" fill={color || "white"} />
        </clipPath>
      </defs>
    </svg>
  );
};

export const viewIcon = (color?: string) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10.3866 7.99995C10.3866 9.31995 9.31995 10.3866 7.99995 10.3866C6.67995 10.3866 5.61328 9.31995 5.61328 7.99995C5.61328 6.67995 6.67995 5.61328 7.99995 5.61328C9.31995 5.61328 10.3866 6.67995 10.3866 7.99995Z"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.9999 13.5138C10.3532 13.5138 12.5466 12.1271 14.0732 9.72714C14.6732 8.78714 14.6732 7.20714 14.0732 6.26714C12.5466 3.86714 10.3532 2.48047 7.9999 2.48047C5.64656 2.48047 3.45323 3.86714 1.92656 6.26714C1.32656 7.20714 1.32656 8.78714 1.92656 9.72714C3.45323 12.1271 5.64656 13.5138 7.9999 13.5138Z"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const bucketIcon = (color?: string) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M13.6663 5.33333V10.8C13.6663 11.9201 13.6663 12.4802 13.4484 12.908C13.2566 13.2843 12.9506 13.5903 12.5743 13.782C12.1465 14 11.5864 14 10.4663 14H5.53301C4.4129 14 3.85285 14 3.42503 13.782C3.0487 13.5903 2.74274 13.2843 2.55099 12.908C2.33301 12.4802 2.33301 11.9201 2.33301 10.8V5.33333M2.39967 2H13.5997C13.973 2 14.1597 2 14.3023 2.07266C14.4278 2.13658 14.5298 2.23856 14.5937 2.36401C14.6663 2.50661 14.6663 2.6933 14.6663 3.06667V4.26667C14.6663 4.64004 14.6663 4.82672 14.5937 4.96933C14.5298 5.09477 14.4278 5.19676 14.3023 5.26067C14.1597 5.33333 13.973 5.33333 13.5997 5.33333H2.39968C2.02631 5.33333 1.83962 5.33333 1.69701 5.26067C1.57157 5.19676 1.46959 5.09477 1.40567 4.96933C1.33301 4.82672 1.33301 4.64004 1.33301 4.26667V3.06667C1.33301 2.6933 1.33301 2.50661 1.40567 2.36401C1.46959 2.23856 1.57157 2.13658 1.69701 2.07266C1.83962 2 2.02631 2 2.39967 2ZM6.39967 7.66667H9.59967C9.97304 7.66667 10.1597 7.66667 10.3023 7.73933C10.4278 7.80324 10.5298 7.90523 10.5937 8.03067C10.6663 8.17328 10.6663 8.35997 10.6663 8.73333V9.26667C10.6663 9.64003 10.6663 9.82672 10.5937 9.96933C10.5298 10.0948 10.4278 10.1968 10.3023 10.2607C10.1597 10.3333 9.97304 10.3333 9.59967 10.3333H6.39967C6.02631 10.3333 5.83962 10.3333 5.69701 10.2607C5.57157 10.1968 5.46959 10.0948 5.40567 9.96933C5.33301 9.82672 5.33301 9.64003 5.33301 9.26667V8.73333C5.33301 8.35997 5.33301 8.17328 5.40567 8.03067C5.46959 7.90523 5.57157 7.80324 5.69701 7.73933C5.83962 7.66667 6.02631 7.66667 6.39967 7.66667Z"
        stroke={color || "white"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const reportExportIcon = (color?: string) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M9 15L12 18M12 18L15 15M12 18L12 12M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z"
        stroke={color ?? "white"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const noDataChartIcon = (color?: string, width?: number, height?: number) => {
  return (
    <svg 
      width={width ?? 80}
      height={height ?? 80}
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color ?? "#d1d5db"}
      strokeWidth="1.5"
      style={{ marginBottom: '16px' }}
    >
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M8 10v7" strokeLinecap="round" />
      <path d="M12 7v10" strokeLinecap="round" />
      <path d="M16 13v4" strokeLinecap="round" />
    </svg>
  );
};
